import { render, staticRenderFns } from "./Setbank.vue?vue&type=template&id=f4c6ea0e&scoped=true"
import script from "./Setbank.vue?vue&type=script&lang=js"
export * from "./Setbank.vue?vue&type=script&lang=js"
import style0 from "./Setbank.vue?vue&type=style&index=0&id=f4c6ea0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c6ea0e",
  null
  
)

export default component.exports